import { request } from "../utils/request.js"


export const fundAccountDetail_findById = (id, args) => request({
    url: 'fundAccountDetail/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const fundAccountDetail_findPageForManage = (pojo, args) => request({
    url: 'fundAccountDetail/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/fundAccountDetail.js